import './js/bootstrap'
import Vue from 'vue'
import App from './App.vue'

Vue.config.productionTip = false

// vant ui
import Vant from 'vant'
import 'vant/lib/index.css';
Vue.use(Vant)

// element ui
import 'element-ui/lib/theme-chalk/index.css';
import {Autocomplete} from "element-ui";
Vue.use(Autocomplete)

import router from './router'
import store from './store'
import './style/index.scss'

import vuexStore from './store/$u.mixin'
Vue.mixin(vuexStore)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
